import { render, staticRenderFns } from "./ImportsSecurityDeposits.vue?vue&type=template&id=cd4bd8a8"
import script from "./ImportsSecurityDeposits.vue?vue&type=script&lang=js"
export * from "./ImportsSecurityDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports